import FilterCategoryWithBreadcrumbs from './filterCategoryWithBreadcrumbs'

export default FilterCategoryWithBreadcrumbs
